import { Reveal } from "./Reveal";

export const Chapter = ({ number, label, title, sub, id, children, wide = false }) => (
  <div className={wide ? "grid lg:grid-cols-[92px_1fr] gap-6 lg:gap-8" : "grid lg:grid-cols-[150px_1fr] gap-6 lg:gap-12"}>
    <Reveal className="lg:pt-2">
      <div className="flex lg:flex-col items-baseline lg:items-start gap-3 lg:gap-0">
        <span
          data-testid={`chapter-${number}-number`}
          className="text-5xl lg:text-6xl font-extrabold tracking-tighter text-nova-blue leading-none"
        >
          {number}
        </span>
        <span className="lg:mt-3 text-[11px] font-bold tracking-[0.28em] uppercase text-nova-muted leading-relaxed max-w-[120px]">
          {label}
        </span>
      </div>
    </Reveal>
    <div>
      <Reveal delay={0.08}>
        <h2
          id={id}
          className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter text-nova-navy leading-[1.05] scroll-mt-44"
        >
          {title}
        </h2>
        {sub && (
          <p className="mt-5 text-base lg:text-lg text-nova-slate leading-relaxed max-w-xl">
            {sub}
          </p>
        )}
      </Reveal>
      {children}
    </div>
  </div>
);
